import React from 'react'
import { useLocation, Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import ArrowLeft from 'assets/icons/go-back-icon'
import EditIcon from 'assets/icons/white-edit-icon'
import ClearIcon from 'assets/icons/clear-icon16px'
import CheckIcon from 'assets/icons/check-icon'
import { ROOT_PATH } from 'routing/constants'
import Button from 'components/Button'
import { TopBarCategoryTitle, TopBarLeftSideWrapper, TopBarRightSideWrapper, TopBarWrapper } from '../Header/style'

import { TopBarButtonWrapper, GoBackButton, EditProfileButton } from './style'

const ProfileHeader = ({
  updateProfileRequest,
  isSubmitting,
  cancelChanges,
  setFormDisabled,
  formDisabled,
  formTouched
}) => {
  const location = useLocation()

  return (
    <TopBarWrapper data-testid="test-profile-header-wrapper" noBorder={true} data-test="header">
      <TopBarLeftSideWrapper>
        <Link
          data-test="go-back"
          to={ROOT_PATH}
          style={{ paddingRight: '10px', textDecoration: 'none', color: '#202020' }}
        >
          <GoBackButton>
            <ArrowLeft />
            <FormattedMessage id="goBack" />
          </GoBackButton>
        </Link>
      </TopBarLeftSideWrapper>
      <TopBarLeftSideWrapper>
        <TopBarCategoryTitle data-test="page-header">
          <FormattedMessage id={location.pathname} />
        </TopBarCategoryTitle>
      </TopBarLeftSideWrapper>
      <TopBarRightSideWrapper>
        <TopBarButtonWrapper>
          {/* eslint-disable-next-line no-negated-condition  */}
          {formDisabled ? (
            <EditProfileButton
              data-test="edit-profile"
              onClick={() => {
                setFormDisabled(false)
              }}
            >
              <EditIcon />
              <FormattedMessage id="editProfile" />
            </EditProfileButton>
          ) : (
            <div style={{ display: 'inline-flex', marginTop: '-34px' }}>
              <Button data-test="cancel" onClick={cancelChanges} type="secondary" height='40px' withIcon={true}>
                <ClearIcon />
                <FormattedMessage id="cancel" />
              </Button>
              <div style={{ marginLeft: '16px' }}>
                <Button
                  isPending={isSubmitting}
                  onClick={updateProfileRequest}
                  data-test="save-changes"
                  isDisabled={!formTouched}
                  height={'40px'}
                  withIcon={true}
                  type={formTouched ? 'primary' : 'disabledPrimary'}
                >
                  <CheckIcon />
                  <FormattedMessage id="saveChanges" />
                </Button>
              </div>
            </div>
          )}
        </TopBarButtonWrapper>
      </TopBarRightSideWrapper>
    </TopBarWrapper>
  )
}

export default ProfileHeader
